import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
export const BACKEND = process.env.REACT_APP_BACKEND_URL;

export const photoSrc = (p) => `${BACKEND}${p.url}`;
export const fileSrc = (url) => (url ? `${BACKEND}${url}` : null);

export const telHref = (phone) => {
  const clean = (phone || "").replace(/[^\d+]/g, "");
  if (clean.startsWith("+")) return `tel:${clean}`;
  if (clean.startsWith("995")) return `tel:+${clean}`;
  return `tel:+995${clean}`;
};

let catCache = null;
let catInflight = null;
let settingsCache = null;
let settingsInflight = null;

export function invalidateCategoryCache() {
  catCache = null;
  catInflight = null;
}

export function invalidateSettingsCache() {
  settingsCache = null;
  settingsInflight = null;
}

export function fetchCategories() {
  if (catCache) return Promise.resolve(catCache);
  if (!catInflight) {
    catInflight = axios
      .get(`${API}/categories`)
      .then((r) => {
        catCache = r.data;
        catInflight = null;
        return r.data;
      })
      .catch(() => {
        catInflight = null;
        return [];
      });
  }
  return catInflight;
}

export function fetchSettings() {
  if (settingsCache) return Promise.resolve(settingsCache);
  if (!settingsInflight) {
    settingsInflight = axios
      .get(`${API}/settings`)
      .then((r) => {
        settingsCache = r.data;
        settingsInflight = null;
        return r.data;
      })
      .catch(() => {
        settingsInflight = null;
        return {};
      });
  }
  return settingsInflight;
}
